@switch (colorScheme()) {
  @case ('default') {
    <link href="/assets/instanceTheme.css" rel="stylesheet" />
  }
  @case ('tan') {
    <link href="/assets/themes/tan.css" rel="stylesheet" />
  }
  @case ('green') {
    <link href="/assets/themes/green.css" rel="stylesheet" />
  }
  @case ('gold') {
    <link href="/assets/themes/gold.css" rel="stylesheet" />
  }
  @case ('red') {
    <link href="/assets/themes/red.css" rel="stylesheet" />
  }
  @case ('pink') {
    <link href="/assets/themes/pink.css" rel="stylesheet" />
  }
  @case ('purple') {
    <link href="/assets/themes/purple.css" rel="stylesheet" />
  }
  @case ('blue') {
    <link href="/assets/themes/blue.css" rel="stylesheet" />
  }
  @case ('rizzler') {
    <link href="/assets/themes/rizzler.css" rel="stylesheet" />
  }
  @case ('leafrn') {
    <link href="/assets/themes/leafrn.css" rel="stylesheet" />
  }
  @case ('contrastWater') {
    <link href="/assets/themes/contrastWater.css" rel="stylesheet" />
  }
  @case ('wafrn98') {
    <link href="/assets/themes/wafrn98.css" rel="stylesheet" />
  }
  @case ('aqua') {
    <link href="/assets/themes/aqua.css" rel="stylesheet" />
  }
  @case ('unwafrn') {
    <link href="/assets/themes/unwafrn.css" rel="stylesheet" />
  }
  @case ('wafrnverse') {
    <link href="/assets/themes/wafrnverse.css" rel="stylesheet" />
  }
  @case ('dracula') {
    <link href="/assets/themes/dracula.css" rel="stylesheet" />
  }
  @case ('fan') {
    <link href="/assets/themes/fan.css" rel="stylesheet" />
  }
  @case ('waffler') {
    <link href="/assets/themes/waffler.css" rel="stylesheet" />
  }
  @case ('cohfrn') {
    <link href="/assets/themes/cohfrn.css" rel="stylesheet" />
  }
  @case ('catppuccin_frappe') {
    <link href="/assets/themes/catppuccin_latte-frappe.css" rel="stylesheet" />
  }
  @case ('catppuccin_macchiato') {
    <link href="/assets/themes/catppuccin_latte-macchiato.css" rel="stylesheet" />
  }
  @case ('catppuccin_mocha') {
    <link href="/assets/themes/catppuccin_latte-mocha.css" rel="stylesheet" />
  }
}

@if (additionalStyleModes.centerLayout()) {
  <link href="/assets/themes/center-column.css" rel="stylesheet" />
}
@if (additionalStyleModes.topToolbar()) {
  <link href="/assets/themes/top-toolbar.css" rel="stylesheet" />
}
@if (additionalStyleModes.lowContrastSidebar()) {
  <link href="/assets/themes/low-contrast-sidebar.css" rel="stylesheet" />
}
@if (additionalStyleModes.oldTags()) {
  <link href="/assets/themes/old-tags.css" rel="stylesheet" />
}
@if (additionalStyleModes.colorfulTags()) {
  <link href="/assets/themes/colorful-tags.css" rel="stylesheet" />
}
@if (additionalStyleModes.solidCards()) {
  <link href="/assets/themes/solid-cards.css" rel="stylesheet" />
}
